import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import {
  MasterProviders,
  EntryForDiscount,
  RequestDicountPayload,
} from '../../../../../core/models/discount.model';
import { StatusAPIResponse } from '../../../../../core/models/information.model';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiParkingService } from '../../../../../core/services/api/Parking/api-parking';
import { ApiPaymentTransactionService } from '../../../../../core/services/api/Payment/api-payment-transaction';
import { ApiParkingTransactionService } from '../../../../../core/services/api/Parking/api-parking-transaction';
import { ApiProviderService } from '../../../../../core/services/api/Parking/api-provider';

@Component({
  selector: 'app-discount-request',
  imports: [CommonModule, FormsModule, PssLoadingComponent,],
  templateUrl: './discount-request.component.html',
  styleUrl: './discount-request.component.css',
})
export class DiscountRequestComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  token: string = '';
  uid: string = '';
  customer_name = '';
  mall_name = '';
  license_plate = '';
  selectedImageFile: File | null = null;
  previewImage: string | null = null;
  modalSelectProvider: boolean = false;
  modalSelectLincense: boolean = false;
  allProviders: MasterProviders[] = [];
  allLicense: EntryForDiscount[] = [];
  statusLoading: boolean = false;
  searchProvider: string = '';
  searchLicense: string = '';
  providerId: number = 0;
  base64String: string = '';
  seq: number = 0;
  disabled: boolean = true;
  providerName: string = '';
  showModal_confirm: boolean = false;
  isLoading: boolean = false;
  sub!: Subscription;
  currentLang: "TH" | "EN" = 'TH';
  statusTransaction: boolean = false;

  // Photo
  previewUrl: string | ArrayBuffer | null = null;
  imageSaved: string | null = null;
  capturedImage: string | null = null;
  isImageExpanded = false;

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''


  constructor(
    private cookieService: CookieService,
    private apiParkingService: ApiParkingService,
    private apiParkingTransactionService: ApiParkingTransactionService,
    private apiProviderService: ApiProviderService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private router: Router,
    private languageService: LanguageService
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit() {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    this.getProviders();
    window.scrollTo(0, 0);
  }

  /* ------------------------------------------- Function ------------------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }
  /*--- Function ---*/
  getProviders() {
    this.isLoading = true;
    this.apiProviderService.GetProvidersDiscount(this.token).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.allProviders = res;
      },
      error: (err) => {
        this.isLoading = false;
        this.showError(
          this.currentLang === 'TH'
            ? 'โหลดข้อมูลล้มเหลว'
            : 'Failed to load data.'
        );
      },
    });
  }

  openMallSelector() {
    if (this.providerId > 0) {
      this.modalSelectLincense = true;
    } else {
      this.showWarning('กรุณาเลือกลานจอด !');
    }
    // เปิด modal หรือเลือกห้างตาม logic
  }
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.selectedImageFile = input.files[0];

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewImage = e.target.result;
        const result = reader.result as string;
        const base64 = result.split(',')[1]; // ตัด header ออก เช่น "data:image/png;base64,"
        this.base64String = base64;
      };
      reader.readAsDataURL(this.selectedImageFile);
    }
  }

  openProviderModol() {
    this.modalSelectProvider = true;
  }

  selectProvider(provider: MasterProviders) {
    this.modalSelectProvider = false;
    this.providerId = provider.id;
    this.providerName = provider.name;
    if (this.providerId > 0) this.getAllLicese();
  }

  filteredProviders(): MasterProviders[] {
    if (!this.searchProvider) return this.allProviders;
    return this.allProviders.filter((p) =>
      p.name.toLowerCase().includes(this.searchProvider.toLowerCase())
    );
  }

  getAllLicese() {
    this.apiParkingTransactionService
      .getTransactionSite(this.token, this.uid, this.providerId)
      .subscribe({
        next: (res) => {
          this.allLicense = res;
        },
        error: (err) => {
          console.error('โหลดข้อมูลล้มเหลว', err);
          this.showError('โหลดข้อมูลล้มเหลว');
        },
      });
  }

  filteredLicense(): EntryForDiscount[] {
    if (!this.searchLicense) return this.allLicense;
    return this.allLicense.filter((p) =>
      p.license.toLowerCase().includes(this.searchLicense.toLowerCase())
    );
  }

  selectLicense(selecter: EntryForDiscount) {
    this.modalSelectLincense = false;
    this.seq = selecter.seq;
    this.license_plate = selecter.license;
    if (this.providerId > 0) this.getAllLicese();
  }

  submitDiscountRequest() {
    if (this.providerId == 0) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกลานจอด'
          : 'Please select the parking location.'
      );
      return;
    }
    if (this.seq == 0) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกทะเบียนรถ'
          : 'Please select the license plate.'
      );
      return;
    }
    if (!this.base64String) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาแนบหรือถ่ายรูปใบเสร็จ'
          : 'Please attach or take a photo of the receipt.'
      );
      return;
    }
  }

  save() {
    this.showModal_confirm = false;
    const payload: RequestDicountPayload = {
      uid: this.uid,
      name: this.customer_name,
      seq: this.seq,
      requestNo: '',
      license: this.license_plate,
      siteId: this.providerId,
      picturePath: this.base64String,
    };
    // console.log('🎯 ส่งคำขอส่วนลด', payload);
    if (payload) {
      this.isLoading = true;
      this.statusLoading = true;
      this.apiParkingService.RequestStamp(payload, this.token).subscribe({
        next: (res: StatusAPIResponse) => {
          this.isLoading = false;
          this.statusLoading = false;
          if (res.code == '000') {
            this.showSuccess(
              this.currentLang === 'TH'
                ? 'ส่งขอส่วนลดสำเร็จ'
                : 'Successfully submitted discount request.'
            );
            this.clear();
          } else {
            this.showError(res.message);
          }
        },
        error: (err) => {
          this.isLoading = false;
          this.statusLoading = false;
          console.error('❌  ไม่สำเร็จ:', err);
          const apiError = err?.error;
          const messageTh = apiError?.message;
          const messageEn = apiError?.message_en;

          const message =
            this.currentLang === 'TH'
              ? messageTh || 'ไม่พบส่วนลดที่ค้นหา'
              : messageEn || 'Not found a discount';

          this.showError(message);
        },
        complete: () => {
          this.isLoading = false;
          this.statusLoading = false;
        },
      });
    } else {
      this.showWarning('Error please try again ');
      return;
    }
  }

  clear() {
    this.customer_name = '';
    this.seq = 0;
    this.previewImage = '';
    this.providerName = '';
    this.license_plate = '';
    this.fileInput.nativeElement.value = '';
  }

  goBack() {
    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 0);
  }

  openModal_Confirm() {
    if (this.providerId == 0) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกลานจอด'
          : 'Please select the parking location.'
      );
      return;
    }
    if (this.seq == 0) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกทะเบียนรถ'
          : 'Please select the license plate.'
      );
      return;
    }
    if (!this.base64String) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาแนบหรือถ่ายรูปใบเสร็จ'
          : 'Please attach or take a photo of the receipt.'
      );
      return;
    }
    this.showModal_confirm = true;
  }

  closeModal_Confirm() {
    this.showModal_confirm = false;
  }

  expandImage() {
    this.isImageExpanded = true;
  }

  closeExpandedImage() {
    this.isImageExpanded = false;
  }

  capture(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
        if (typeof reader.result === 'string') {
          const base64 = reader.result.split(',')[1] || '';
          this.base64String = base64;
        } else {
          this.base64String = '';
        }
      };
      reader.readAsDataURL(file);
    }
  }
}
